import { SlideComponentCharacterWriting } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentCharacterWritingCreator extends SlideComponentCreator {
    public create(id: string): SlideComponentCharacterWriting {
        return {
            id: id,
            type: 'characterWriting',
            pos: {
                x: 0,
                y: 0,
            },
            size: { width: 400, height: 400 },
            content: {
                code: '',
                locale: '',
                character: '',
            },
        };
    }
}
